module.exports = __webpack_public_path__ + "img/img-dbfb1e24.17ccfa3b.png";